module.exports = __webpack_public_path__ + "img/09.b47c6d7d.png";